/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_SCHEDULE } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { capitalCase } from "change-case";

import { StorageModule } from "@vlinder-web/storage-module-react";
import { pretty } from "@vlinder-web/utils-react";

const storageService = StorageModule.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateScheduleMethods extends IPluginMethodMap {
  updateSchedule(args: any): Promise<any>;
}

export class UpdateScheduleService implements IAgentPlugin {
  readonly methods: IUpdateScheduleMethods;

  constructor() {
    this.methods = {
      updateSchedule: this.updateSchedule.bind(this),
    };
  }

  async updateSchedule(args: any) {
    console.log(`updateSchedule service : `, pretty(args?.payload));
    const graphqlModule = getGraphQLModule();
    let update = args?.payload?.update
    let filter = args?.payload?.filter
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_SCHEDULE,
          variables: {
            filter: filter,
            update: {
              ...update,
              band: storageService.get("bandConfig", "local")?.band?.appCardId,
              sections: args?.payload?.update?.sections?.section,
              newSectionOptTypes: args?.payload?.update?.sections?.sectionOpt,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return res?.data?.updateSchedule;
        }
      }
    } catch (err: any) {
      console.log(`error in create schedule`, err);
      throw err;
      return {
        isEmpty: true,
      };
    }
  }
}
